import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import "../../../assets/js/app_agreement.js";

declare var agreement: any;
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: []
})
export class ContactComponent implements OnInit {
  loading = false;
  constructor(private http: HttpClient) {
    window.scrollTo(0, 0);
    this.contactForm = new FormGroup({
      company: new FormControl(),
      name: new FormControl('', [
        Validators.required,
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
      ]),
      phone: new FormControl('', [
        Validators.required,
      ]),
      message: new FormControl('', [
        Validators.required,
      ])
    });
  }
  contactForm: FormGroup;
  nameValid: boolean = true;
  mailValid: boolean = true;
  phoneValid: boolean = true;
  messageValid: boolean = true;
  formValid: boolean = false;

  ngOnInit() {
    agreement.init();

  }
  onSubmit() {
    this.loading = true;
    if (!this.contactForm.controls['name'].valid) {
      this.nameValid = false;
    } else this.nameValid = true;

    if (!this.contactForm.controls['email'].valid) {
      this.mailValid = false;
    } else this.mailValid = true;

    if (!this.contactForm.controls['phone'].valid) {
      this.phoneValid = false;
    } else this.phoneValid = true;

    if (!this.contactForm.controls['message'].valid) {
      this.messageValid = false;
    } else this.messageValid = true;

    if (this.nameValid && this.mailValid && this.phoneValid && this.messageValid)
      this.saveInfo();
    else this.loading = false;
  }
  checkPhone() {
    if (this.contactForm.controls["phone"].value[0] == '0')
      this.contactForm.controls["phone"].setValue(this.contactForm.controls["phone"].value.substr(1));
  }
  saveInfo() {
    let url = environment.notificationUrl + "/v1/notifications/email"
    let raw = this.contactForm.getRawValue();
    let req = {
      subject: "(WEB) İletişim Başvurusu",
      params: {
        "Şirket Adı": raw.company,
        "Ad Soyad": raw.name,
        "E-Posta": raw.email,
        "Telefon": raw.phone,
        "Mesaj": raw.message
      }
    };
    this.http
      .post(url, req)
      .subscribe(
        responseData => {
          this.loading = false;
          this.formValid = true;
        },
        error => {
          this.loading = false;
          this.formValid = true;
        }
      );
  }
}
